<template>
    <h3 v-if="isLoggedIn && savedPP.length > 0" id="product-planner-tab" class="sub-header pb-0 mb-0">Saved Product Planner</h3>
    <div v-if="isLoggedIn && savedPP.length > 0" class="table-responsive">
        <table class="table table-striped table-bordered text-center mb-0">
            <thead class="bg-grey">
                <tr>
                    <th>Event Name</th>
                    <th>Date</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(ppl_quote, index) in savedPP" :key="index">
                    <td>
                        <a :href="`/edit-product-planner/${ppl_quote.id}`">{{
                        ppl_quote.event_name
                        }}</a>
                    </td>
                    <td>{{ formatDateWithDashNew(ppl_quote.event_date) }}</td>
                    <td>
                        <a :href="`/edit-product-planner/${ppl_quote.id}`"><EditIcon /></a>
                        <div class="deleteIcon d-inline-block">
                            <div class="w-100 d-block d-md-none"></div>
                            <ToolTip content="Delete">
                                <a class="px-2" href="#" @click="showDeletePPWarn(ppl_quote.id)">
                                    <DeleteIcon />
                                </a>
                            </ToolTip>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <modal-message
            v-if="deletePPModal.show"
            :closeFn="hideDeletePPWarn"
            closeBtn="Cancel"
            closeBtnAction="secondary"
            :submitFn="deletePP"
            submitBtn="OK"
            submitBtnAction="primary"
        >
            Are you sure, you want to delete product planner?
        </modal-message>
    </div>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance } from "vue";
import { useRoute, useRouter } from "vue-router";
import DeleteIcon from './DeleteIcon.vue';
import EditIcon from './EditIcon.vue';
import { useActions, useGetters, useMutations, useMisc, useState } from "@/composables";
import axios from "axios";
import ModalMessage from "./ModalMessage.vue";
import ToolTip from "./ToolTip.vue";

const emit = defineEmits(['showFlashAlertMessage']);

const { deletePP } = useActions();
const { isLoggedIn } = useGetters();
const { showDeletePPWarn, hideDeletePPWarn } = useMutations();
const { deletePPModal } = useState();
const { formatDateWithDashNew } = useMisc();

const route = useRoute();
const router = useRouter();
const instance = getCurrentInstance();
const emitter = instance.appContext.config.globalProperties.emitter;

// Data
const savedPP = ref([]);

// Methods
const fetchSavedPP = () => {
    try {
        if (isLoggedIn.value) {
            axios
                .get(
                    process.env.VUE_APP_API_BASE + "auth/getSavedProductPlanners",
                    {
                        headers: {
                            "Content-type": "application/json",
                            Authorization: "Bearer " + localStorage.getItem("token"),
                        },
                    }
                )
                .then((response) => {
                    savedPP.value = response.data.product_planners;
                });
        }
    } catch {
        console.log("Something went wrong");
    }
};

const PPDeleted = (payload) => {
    if (route.params.id == payload.deleted_pp_id) {
        router.push("/product-planner");
    } else {
        fetchSavedPP();
    }
    emit('showFlashAlertMessage', payload.msg, payload.level);
    emitter.emit("hideLoader");
};

// Lifecycle
onMounted(() => {
    fetchSavedPP();
    emitter.on("deletedPP", (payload) => {
        PPDeleted(payload);
    });
});
</script>